import { V2CircuitCircuitDataByRoomIdPostResponse } from '@maxtropy/dmes-apis-v2';
import { DeviceTreeProps } from '../../api/device';
import { CircuitType } from '@/api/circuit';

export const formatTreeData = (tree: DeviceTreeProps[]) => {
  let res: DeviceTreeProps[] = [];
  tree.forEach(i => {
    if (i.name === '电表') {
      res = res.concat(i.children ?? []);
    }
  });
  return res;
};

export type DataItem = Exclude<V2CircuitCircuitDataByRoomIdPostResponse['list'], undefined>[number];

export const ColorTypeProps = {
  [CircuitType.GRID_BILLING_CIRCUIT]: '#FF0000',
  [CircuitType.OUTGOING_CIRCUIT]: '#FEFF01',
  [CircuitType.INCOMING_CIRCUIT]: '#00ADFF',
  [CircuitType.BUS_COUPLER_CIRCUIT]: '#028001',
  [CircuitType.TRANSFORMER_CIRCUIT]: '#FE45FF',
};

export enum SwitchStatus {
  NONE = 0,
  CLOSING = 1,
  OPENING = 2,
}

export interface GraphNode {
  id: string;
  circuitId?: string;
  name: string;
  type?: CircuitType;

  electricCurrentA?: string;
  electricCurrentB?: string;
  electricCurrentC?: string;
  target?: PlainNode;
  leftTarget?: PlainNode; // 整体拓扑使用
  rightTarget?: PlainNode; // 整体拓扑使用

  power?: string;
  hasOu?: boolean;
  isAlarm?: boolean;
  switchStatus?: SwitchStatus;
  targetInCurrentStation?: boolean;
  hasDevice?: boolean;
}

export interface OverViewGraphProps {
  nodes: any[];
  edges: any[];
  combos?: any[];
}

export interface GraphProps {
  id: string;
  value: GraphNode;
  children: GraphProps[];
}

export const levelDisplay: Record<number, string> = {
  0: '全拓扑',
  1: '一级',
  2: '二级',
  3: '三级',
  4: '四级',
  5: '五级',
  6: '六级',
  7: '七级',
  8: '八级',
  9: '九级',
  10: '十级',
};

export interface CircuitNode {
  circuitId: number;
  circuitName: string;
  type: number;
  source?: PlainNode;
  children?: CircuitNode[];
}

export interface PlainNode {
  circuitId: number;
  circuitName: string;
  roomId: number;
  roomName: string;
  fromOrTo?: number; //0引自  1引至
}
